/**
 * 地理坐标点
 */
export interface IPoint {
  /**
   * 点的id
   */
  id?: string
  /**
   * 地理经度
   */
  lng: number
  /**
   * 地理纬度
   */
  lat: number
  /**
   * 点的类型
   */
  type?: string
}

/**
 * 尺寸
 */
export interface ISize {
  /**
   * 宽度
   */
  width: number
  /**
   * 高度
   */
  height: number
}

/**
 * 地图标注
 */
export interface IMarker {
  /**
   * 地图标注id
   */
  id?: string
  /**
   * 地图标注位置
   */
  loc: IPoint
  /**
   * 地图标注icon
   */
  icon: string
  /**
   * 地图标注尺寸
   */
  size?: ISize
  /**
   * 地图标注的层级
   */
  zIndex?: number
  /**
   * 地图标注携带的数据
   */
  data?: unknown
}

/**
 * 地图线路绘制选项
 */
export interface IStrokeOptions {
  /**
   * 地图线路颜色
   */
  strokeColor?: string
  /**
   * 地图线路宽度
   */
  strokeWeight?: number
  /**
   * 地图线路透明度
   */
  strokeOpacity?: number
}

/**
 * 地图线路
 */
export interface ILine {
  /**
   * 路线id
   */
  id?: string
  /**
   * 地图线路点
   */
  points: IPoint[]
  /**
   * 地图线路绘制选项
   */
  options?: IStrokeOptions
  /**
   * 地图线路是否可点击
   */
  clickable?: boolean
}

/**
 * 贝塞尔曲线
 */
export interface ICurve {
  /**
   * 路线id
   */
  id?: string
  /**
   * 地图线路点
   */
  points: IPoint[]
  /**
   * 控制点
   */
  controlPoints?: IPoint[]
  /**
   * 地图线路绘制选项
   */
  options?: IStrokeOptions
}

/**
 * 地图线路
 */
export interface ILabel {
  /**
   * 路线id
   */
  id?: string
  /**
   * label点位置
   */
  point: IPoint
  /**
   * label内容
   */
  content: string
  /**
   * 地图label绘制选项
   */
  options?: any
}

/**
 * 加电资源类型
 */
export enum PowerResourceType {
  /**
   * 换电站
   */
  PowerSwap = 'PowerSwap',
  /**
   * nio充电站
   */
  ChargeStation = 'NioChargeStationNpc;NioChargeStationDest',
  /**
   * nio超充桩
   */
  NioChargeStationNpc = 'NioChargeStationNpc',
  /**
   * nio目的地充电桩
   */
  NioChargeStationDest = 'NioChargeStationDest',
  /**
   * 三方桩
   */
  ThirdChargeStation = 'ThirdChargeStation',
  /**
   * 蔚来空间
   */
  NioSpace = 'nio_space',
  /**
   * 蔚来中心
   */
  NioHouse = 'nio_house',
  /**
   * 蔚来路演
   */
  NioRoadShow = 'nio_road_show',
  /**
   * 试驾点
   */
  TestDrive = 'test_drive',
  /**
   * 服务中心
   */
  ServiceCenter = 'service_center',
  /**
   * 聚合资源
   */
  Merged = 'Merged',
  /**
   * 未知
   */
  Unknown = 'Unknown',
}
